module.exports = "pegasus/assets/preview-2.png";